import React from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { useNotificationStore } from '@/store/notificationStore';
import { Notification } from './Notification';
import styles from './Notifications.module.scss';

/**
 * Wrapper that handles notifications from global client state.
 * Remember to only add this to the project once - else the notifications gets rendered twice.
 */
export const Notifications: React.FunctionComponent = () => {
	const notifications = useNotificationStore((state) => state.notifications);
	const clearNotifications = useNotificationStore((state) => state.clearNotifications);

	const location = useLocation();

	React.useEffect(() => {
		clearNotifications();
	}, [location, clearNotifications]);

	return (
		<div className={classNames(styles.list, 'u-container-sm')}>
			{notifications.map(({ children, id, ...rest }) => (
				<Notification {...rest} id={id} key={id}>
					{children}
				</Notification>
			))}
		</div>
	);
};
